import { Link } from 'react-router-dom'
import { cn } from '@/lib/utils'

export interface SectionHeaderProps {
  title: string
  count?: number
  viewAllLink?: string
  action?: {
    label: string
    icon?: React.ReactNode
    onClick: () => void
  }
  className?: string
}

export function SectionHeader({
  title,
  count,
  viewAllLink,
  action,
  className,
}: SectionHeaderProps) {
  const titleElement = viewAllLink ? (
    <Link
      to={viewAllLink}
      className="group -mx-2 inline-flex items-center gap-2 rounded-lg px-2 py-1 text-xl font-semibold text-[#0033A0] transition-all duration-200 hover:bg-[#0033A0]/5 hover:text-[#002B87] focus:outline-none focus:ring-2 focus:ring-[#0033A0] focus:ring-offset-2"
    >
      <span className="underline decoration-[#0033A0]/30 decoration-2 underline-offset-4 transition-all duration-200 group-hover:decoration-[#0033A0]">
        {title}
      </span>
      {count !== undefined && <span className="text-gray-500">({count})</span>}
      <svg
        className="h-4 w-4 transition-all duration-200 group-hover:translate-x-0.5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 5l7 7-7 7"
        />
      </svg>
      <span className="text-sm font-normal text-gray-500">View all</span>
    </Link>
  ) : (
    <h2 className="text-xl font-semibold text-gray-900">
      {title}
      {count !== undefined && (
        <span className="ml-2 text-gray-500">({count})</span>
      )}
    </h2>
  )

  return (
    <div
      className={cn(
        'sticky top-14 z-40 -mx-4 mb-4 flex items-center justify-between bg-[#F9F9F9] px-4 py-2 sm:static sm:mx-0 sm:mb-6 sm:bg-transparent sm:px-0',
        className
      )}
    >
      {titleElement}

      <div className="flex items-center gap-3">
        {action && (
          <button
            onClick={action.onClick}
            className="flex items-center gap-1.5 rounded-lg bg-[#0033A0] px-3 py-1.5 text-sm font-medium text-white transition-colors hover:bg-[#002B87] focus:outline-none focus:ring-2 focus:ring-[#0033A0] focus:ring-offset-2"
          >
            {action.icon}
            {action.label}
          </button>
        )}
      </div>
    </div>
  )
}
